import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';

import Actions from '../../redux/modules/notifications';

class NotificationList extends React.Component {
    state = {
        show: false,
        badgeNum: 0,
    }

    toggle = () => {
        this.setState(state => ({
            show: !state.show
        }));
    }

    render() {
        const { show, badgeNum } = this.state;
        const { list } = this.props;

        return(
            <div className="notification-container">
                <div className="bell-container" onClick={this.toggle}>
                    <i className="fa fa-bell-o" />
                    {badgeNum ? <span className="badge badge-danger badge-pill">{badgeNum}</span> : null }
                </div>
                {show ? (
                    <div className="notification-list">
                        {list.length ? (
                            list.map(notif => (
                                <Link key={notif.entityId} to={`/${notif.entityType}/${notif.entityId}`}>
                                    <div className="notification-item cursor-pointer">
                                        <p className="m-0">{notif.title}</p>
                                        <small>{notif.description}</small>
                                    </div>
                                </Link>
                            ))
                        ) : (
                            <div className="notification-item center-item">
                                <span>No Notifications Yet</span>
                            </div>
                        )}
                    </div>
                ) : null}
            </div>
        )
    }
}

const mapStateToProps = ({
    notifications: {
        list,
    },
}) => ({
    list,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationList);